import React, { Fragment, Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actions from '../figure/action/contraente'
import * as actionType from '../figure/actionType/contraente';
import * as actionsBenefMorteGiuridico from '../figure/action/beneficiarioMorte';
import * as actionTypeBenefMorteGiuridico from '../figure/actionType/beneficiarioMorte';
import * as actionsBenefVitaGiuridico from '../figure/action/beneficiarioVita';
import * as actionTypeBenefVitaGiuridico from '../figure/actionType/beneficiarioVita';
import * as actionsTitolareEff from '../figure/action/titolareEff'
import * as actionTypeTitolareEff from '../figure/actionType/titolareEff';

import { CONTRAENTE_GIURIDICO, BENEF_MORTE_GIURIDICO, BENEF_VITA_GIURIDICO, CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE, CODICE_SAE_FIDUCIARIA_GESTIONE, FIDUCIARIA_CONTO_PROPRIO,FIDUCIARIA_CONTO_TERZI } from '../../../utility/jsConstants';
import DividerComp from '../../common/DividerComp';
import { Grid } from '@material-ui/core';
import NumberFieldComp from '../../common/NumberFieldComp';
import { textTrim } from '../../../utility/genericUtility';
import RadioButtonComp from '../../common/RadioButtonComp';
import { radioButtonIntestatarioMandato } from '../../store/radioButtonStore';
import { radioButtonFiduciariaContoProContoTerz } from '../../store/radioButtonStore';
import { errorFiducianteContraente, errorFiducianteMorte } from '../../../utility/storeUtility';


const styles = theme => ({
    textField: theme.textField,
    dateField: theme.dateField,
    textFieldWidthPerc: theme.textFieldWidthPerc,
    textFieldWidthPercError: theme.textFieldWidthPercError,
    fieldSet: theme.fieldSet,
    divider: {
        width: theme.spacing(1),
    },
    button: theme.button,
    textErrorMessage: theme.textErrorMessage,
});


const mapStateToProps = (state) => ({
    datiMandatoFiduciario: state.areaContraenteReducer.contraenteGiuridico.datiMandatoFiduciario,
    controlloDatiContraenteGiuridico: state.areaContraenteReducer.contraenteGiuridico.controlloDati,
    controlloDatiBenefVitaGiuridico: state.areaBenefVitaReducer.benefVitaGiuridico.controlloDati,
    controlloDatiBenefMorteGiuridico: state.areaBenefMorteReducer.benefMorteGiuridico.controlloDati,
    datiMandatoFiduciarioBenefMorteGiuridico: state.areaBenefMorteReducer.benefMorteGiuridico.datiMandatoFiduciario,
    datiMandatoFiduciarioBenefVitaGiuridico: state.areaBenefVitaReducer.benefVitaGiuridico.datiMandatoFiduciario,
    saeContraenteGiuridico: state.areaContraenteReducer.contraenteGiuridico.datiAttEconomicaGiuridico.codSAE,
    saeBenefMorteGiuridico: state.areaBenefMorteReducer.benefMorteGiuridico.datiAttEconomica.codSAE,
    saeBenefVitaGiuridico: state.areaBenefVitaReducer.benefVitaGiuridico.datiAttEconomica.codSAE,
    scopeAmleto: state.genericReducer.generic.proposalInfo.scopeAmleto,
    //contrGiuSae: state.areaContraenteReducer.contraenteGiuridico.datiAttEconomicaGiuridico.codSAE
})


const mapDispatchToProps = dispatch => {
    return {
        updateDatiMandatoFiduciario: (unDato, unActionType, figura) => dispatch(actions.updateDatiMandatoFiduciario(unDato, unActionType, figura)),
        updateDatiMandatoFiduciarioBenefMorteGiuridico: (unDato, unActionType) => 
                        dispatch(actionsBenefMorteGiuridico.updateDatiMandatoFiduciarioBenefMorteGiuridico(unDato, unActionType)),
        updateDatiMandatoFiduciarioBenefVitaGiuridico: (unDato, unActionType) => 
                        dispatch(actionsBenefVitaGiuridico.updateDatiMandatoFiduciarioBenefVitaGiuridico(unDato, unActionType)),
        updateDatiTitolareEff: (unDato, unActionType) => dispatch(actionsTitolareEff.updateDatiTitolareEff(unDato, unActionType))
    }
};

class DatiMandatoFiduciario extends Component {
    constructor(props) {
        super(props);
        const datiMandatoFiduciario = this.datiMandatoFiduciarioFrom(this.props.figura);
        this.state = {
        	statoCampi: this.initStatoCampi(),
        	isPresenteErrore: null,
            numeroMandatoFid: datiMandatoFiduciario.numeroMandatoFid,
            intestatarioMandato: datiMandatoFiduciario.intestatarioMandato,
            fiduciariaContoProContoTerz: datiMandatoFiduciario.fiduciariaContoProContoTerz,
        };
    };

    codiceSaeFrom = (figura) => {
        let codSae = null;
        if(figura === CONTRAENTE_GIURIDICO) {
            codSae = this.props.saeContraenteGiuridico;
        } else if(figura === BENEF_MORTE_GIURIDICO) {
            codSae = this.props.saeBenefMorteGiuridico;
        } else if(figura === BENEF_VITA_GIURIDICO) {
            codSae = this.props.saeBenefVitaGiuridico;
        }
        return codSae;
    }

    initStatoCampi = () => {
        return [
            { id: 'numeroMandatoFiduciario', isError: false },
            { id: 'intestatarioMandatoFid', isError: false },
            { id: 'fiduciariaContoProContoTerz', isError: false },
        ]
    }
    
    
    handleError = (id, isError) => {
        let unErrore = null;
        let campoOnId = this.state.statoCampi.filter(unCampo => unCampo.id === id);
        let campoWithoutId = this.state.statoCampi.filter(unCampo => unCampo.id !== id);
        if (campoOnId.length > 0) {
          unErrore = campoOnId[0];
          unErrore.isError = isError;
        } else {
          unErrore = { id: id, isError: isError };
        }
        this.setState({	
          statoCampi: [...campoWithoutId, unErrore],      
        });
    }

    isRequiredIntestatarioMandato = () => {
    	//return this.isMandatoFiduciario();
    	return this.isMandatoFiduciarioContoTerzi();
    }

    isRequiredNumeroMandato = () => {
    	//return this.isMandatoFiduciario();
    	return this.isMandatoFiduciarioContoTerzi();
    }

    isMandatoFiduciarioContoTerzi = () => {
    	let required = false;
    	if (this.isMandatoFiduciario()) {
    		const datiMandatoFiduciario = this.datiMandatoFiduciarioFrom(this.props.figura);
	        const fiduciariaContoProContoTerz = datiMandatoFiduciario.fiduciariaContoProContoTerz;
	        required = FIDUCIARIA_CONTO_TERZI === fiduciariaContoProContoTerz;
    	}
    	return required;
    }
    
    isRequiredFiduciariaContoProContoTerz = () => {
  	  return this.isMandatoFiduciario();
    }
    
    isMandatoFiduciario = () => {
    	let isFiduciaria = false;
        if(this.props.scopeAmleto) {
        	let codiceSae = this.codiceSaeFrom(this.props.figura);
            if(codiceSae === CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE || codiceSae === CODICE_SAE_FIDUCIARIA_GESTIONE) {
            	isFiduciaria = true;
            }
        }
        return isFiduciaria;
    }
    
    
    
    static getDerivatedStateFromProps() {
        
    }

    datiMandatoFiduciarioFrom = figura => {
        let datiMandatoFiduciario = null;
        if (figura === CONTRAENTE_GIURIDICO) {
            datiMandatoFiduciario = this.props.datiMandatoFiduciario
        } else if(figura === BENEF_MORTE_GIURIDICO) {
            datiMandatoFiduciario = this.props.datiMandatoFiduciarioBenefMorteGiuridico
        } else if(figura === BENEF_VITA_GIURIDICO) {
            datiMandatoFiduciario = this.props.datiMandatoFiduciarioBenefVitaGiuridico
        }
        return datiMandatoFiduciario;
    }

    controlloDatiFrom = figura => {
        let controlloDati = null;
        if (figura === CONTRAENTE_GIURIDICO) {
            controlloDati = this.props.controlloDatiContraenteGiuridico
        } else if(figura === BENEF_MORTE_GIURIDICO) {
            controlloDati = this.props.controlloDatiBenefMorteGiuridico
        } else if(figura === BENEF_VITA_GIURIDICO) {
            controlloDati = this.props.controlloDatiBenefVitaGiuridico
        }
        return controlloDati;
    }

    handleChangeIntestatarioMandato = event => {
        const nuovoIntestatario = ((event === null) || (event === undefined)) ? '' : textTrim(event.target.value, true);
        const vecchioIntestatario = textTrim(this.props.intestatarioMandato, true);
        if (nuovoIntestatario !== vecchioIntestatario) {
            if(this.props.figura === BENEF_MORTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(nuovoIntestatario, actionTypeBenefMorteGiuridico.UPDATE_INTESTATARIO_MANDATO_BENEF_MORTE_GIURIDICO)
            } else if(this.props.figura === BENEF_VITA_GIURIDICO) {
                this.props.updateDatiMandatoFiduciarioBenefVitaGiuridico(nuovoIntestatario, actionTypeBenefVitaGiuridico.UPDATE_INTESTATARIO_MANDATO_BENEF_VITA_GIURIDICO)
            } else if (this.props.figura === CONTRAENTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciario(nuovoIntestatario, actionType.UPDATE_INTESTATARIO_MANDATO, this.props.figura);
            }
            this.setState({
                intestatarioMandato: (event === null) ? '' : event.target.value,
            })
        }
    }

    handleChangeDatiMandatoFiduciario = event => {
        const nuovoNumeroMandato = textTrim(event.target.value, true);
        const datiMandFiduc = this.datiMandatoFiduciarioFrom(this.props.figura);
        const vecchioNumeroMandato = textTrim(datiMandFiduc.numeroMandatoFid, true);
        if (nuovoNumeroMandato !== vecchioNumeroMandato) {
            if(this.props.figura === BENEF_MORTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(nuovoNumeroMandato, actionTypeBenefMorteGiuridico.UPDATE_MANDATO_BENEF_MORTE_GIURIDICO);
            } else if(this.props.figura === BENEF_VITA_GIURIDICO) {
                this.props.updateDatiMandatoFiduciarioBenefVitaGiuridico(nuovoNumeroMandato, actionTypeBenefVitaGiuridico.UPDATE_MANDATO_BENEF_VITA_GIURIDICO);
            } else if (this.props.figura === CONTRAENTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciario(nuovoNumeroMandato, actionType.UPDATE_NUM_MANDATO_FIDUCIARIO, this.props.figura);
            }
            this.setState({
                numeroMandatoFid: nuovoNumeroMandato,
            })
        }
    }
    
    handleChangeFiduciariaContoProContoTerz = event => {
        const nuovoFiduciariaContoProContoTerz = textTrim(event.target.value, true);
        const datiMandFiduc = this.datiMandatoFiduciarioFrom(this.props.figura);
        const fiduciariaContoProContoTerz = datiMandFiduc.fiduciariaContoProContoTerz;
        
        const vecchioFiduciariaContoProContoTerz = textTrim(datiMandFiduc.fiduciariaContoProContoTerz, true);
        if (nuovoFiduciariaContoProContoTerz !== vecchioFiduciariaContoProContoTerz) {
            if(this.props.figura === BENEF_MORTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(nuovoFiduciariaContoProContoTerz, actionTypeBenefMorteGiuridico.UPDATE_FIDUCIANTE_CONTO_PRO_CONTO_TERZ_BENEF_MORTE_GIURIDICO);
                
              //2026-01-19 PFD: Gestione Fiduciaria Conto Proprio Conto Terzi
                if (FIDUCIARIA_CONTO_PROPRIO === nuovoFiduciariaContoProContoTerz) {
	                //Azzero Numero Mandato e intestatario Mandato
	                this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico("", actionTypeBenefMorteGiuridico.UPDATE_MANDATO_BENEF_MORTE_GIURIDICO, this.props.figura);
	                this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico("", actionTypeBenefMorteGiuridico.UPDATE_INTESTATARIO_MANDATO_BENEF_MORTE_GIURIDICO, this.props.figura);
                }
                
                const isFiduciaria = this.props.saeBenefMorteGiuridico === CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE || this.props.saeBenefMorteGiuridico === CODICE_SAE_FIDUCIARIA_GESTIONE;
                const errFiduciante = errorFiducianteMorte(isFiduciaria, nuovoFiduciariaContoProContoTerz);
          	
          	    this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(errFiduciante.errFiducianteContoProprio, actionTypeBenefMorteGiuridico.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_CONTO_PROPRIO);
          	    this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(errFiduciante.errFiducianteContoTerzi, actionTypeBenefMorteGiuridico.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_CONTO_TERZI);
          	    this.props.updateDatiMandatoFiduciarioBenefMorteGiuridico(errFiduciante.errFiducianteInLista, actionTypeBenefMorteGiuridico.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_IN_LISTA);
          	    
            } else if(this.props.figura === BENEF_VITA_GIURIDICO) {            	
                this.props.updateDatiMandatoFiduciarioBenefVitaGiuridico(nuovoFiduciariaContoProContoTerz, actionTypeBenefVitaGiuridico.UPDATE_FIDUCIANTE_CONTO_PRO_CONTO_TERZ_BENEF_VITA_GIURIDICO);
                
                //2026-01-19 PFD: Gestione Fiduciaria Conto Proprio Conto Terzi
                //2026-01-19 PFD: Non abbiamo in ZSemplifico prodotti con Beneficiario Vita.
                //                Recuperare la gestione dell'erroreFiduciante come avviene per il BenefMorte e Contraente
            } else if (this.props.figura === CONTRAENTE_GIURIDICO) {
                this.props.updateDatiMandatoFiduciario(nuovoFiduciariaContoProContoTerz, actionType.UPDATE_FIDUCIANTE_CONTO_PRO_CONTO_TERZ, this.props.figura);
                
              //2026-01-19 PFD: Gestione Fiduciaria Conto Proprio Conto Terzi
                if (FIDUCIARIA_CONTO_PROPRIO === nuovoFiduciariaContoProContoTerz) {
	                //Azzero Numero Mandato e intestatario Mandato
	                this.props.updateDatiMandatoFiduciario("", actionType.UPDATE_NUM_MANDATO_FIDUCIARIO, this.props.figura);
	                this.props.updateDatiMandatoFiduciario("", actionType.UPDATE_INTESTATARIO_MANDATO, this.props.figura);
                }
              
                const isFiduciaria = this.props.saeContraenteGiuridico === CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE || this.props.saeContraenteGiuridico === CODICE_SAE_FIDUCIARIA_GESTIONE;
                const errFiduciante = errorFiducianteContraente(isFiduciaria, nuovoFiduciariaContoProContoTerz);
          	
          	    this.props.updateDatiTitolareEff(errFiduciante.errFiducianteContoProprio, actionTypeTitolareEff.UPDATE_ERRORE_FIDUCIANTE_TE_CONTRAENTE_CONTO_PROPRIO);
          	    this.props.updateDatiTitolareEff(errFiduciante.errFiducianteContoTerzi, actionTypeTitolareEff.UPDATE_ERRORE_FIDUCIANTE_TE_CONTRAENTE_CONTO_TERZI);
          	    this.props.updateDatiTitolareEff(errFiduciante.errFiducianteInLista, actionTypeTitolareEff.UPDATE_ERRORE_FIDUCIANTE_TE_CONTRAENTE_IN_LISTA);	
            }
            this.setState({
            	fiduciariaContoProContoTerz: nuovoFiduciariaContoProContoTerz,
            })
        }
        
    }
    
    isDisabledNumeroMandato = () => {
    	const isFiduciariaContoTerzi = this.isMandatoFiduciarioContoTerzi();
    	const disabled = isFiduciariaContoTerzi === true ? false : true;
    	return disabled;
    }

    isDisabledIntestatarioMandato = () => {
    	const isFiduciariaContoTerzi = this.isMandatoFiduciarioContoTerzi();
    	const disabled = isFiduciariaContoTerzi === true ? false : true;
    	return disabled;
    }
    
    isDisabledFiducContoProContoTerz = () => {
    	const isFiduciaria = this.isMandatoFiduciario();
    	const disabled = isFiduciaria === true ? false : true;
    	return disabled;
    }

    render() {
        const { labelFieldSet, classes, figura } = this.props;
        const datiMandatoFiduciario = this.datiMandatoFiduciarioFrom(figura);
        const controlloDati = this.controlloDatiFrom(figura);
        return (
            <Fragment>
                <DividerComp titolo={labelFieldSet} variant='subtitle1' />
                <Grid container direction='row' justify='flex-start' alignItems='center'>
                {/*
                    <NumberFieldComp id='numeroMandatoFiduciario' aStyle={classes.textFieldWidthPerc} onError={this.handleError} required={this.isRequiredNumeroMandato()}
                        onBlur={this.handleChangeDatiMandatoFiduciario} value={datiMandatoFiduciario.numeroMandatoFid} controlloDati={controlloDati}
                        label='numeroMandatoFid' disabled={this.isDisabledNumeroMandato()} aStyleError={classes.textFieldWidthPercError} />

                    <Grid container direction='row' justify='center' alignItems='flex-start'>
	                    <Grid item md={4} xs={12}>
	                        <RadioButtonComp id='intestatarioMandatoFid' radioComp={radioButtonIntestatarioMandato} onError={this.handleError}
	                            controlloDati={controlloDati} required={this.isRequiredIntestatarioMandato()} onChange={this.handleChangeIntestatarioMandato}
	                            selectedValue={datiMandatoFiduciario.intestatarioMandato} classes={{ divider: classes.divider }} disabled={this.isDisabledIntestatarioMandato()} />
	                    </Grid>
	                       
	                    
	                    <Grid item md={4} xs={12}>
		                    <RadioButtonComp id='fiduciariaContoProContoTerz' radioComp={radioButtonFiduciariaContoProContoTerz} onError={this.handleError} 	                      
		                       controlloDati={controlloDati} required={this.isRequiredFiduciariaContoProContoTerz()} onChange={this.handleChangeFiduciariaContoProContoTerz}
		                       selectedValue={datiMandatoFiduciario.fiduciariaContoProContoTerz} classes={{ divider: classes.divider }} disabled={this.isDisabledFiducContoProContoTerz()} />
		                </Grid>
		                <Grid item md={4} xs={12} />
	                </Grid>
	                */}
	                <Grid item md={4} xs={12}>
	                	<RadioButtonComp id='fiduciariaContoProContoTerz' radioComp={radioButtonFiduciariaContoProContoTerz} onError={this.handleError} 	                      
	                		controlloDati={controlloDati} required={this.isRequiredFiduciariaContoProContoTerz()} onChange={this.handleChangeFiduciariaContoProContoTerz}
	                		selectedValue={datiMandatoFiduciario.fiduciariaContoProContoTerz} classes={{ divider: classes.divider }} disabled={this.isDisabledFiducContoProContoTerz()} />
	                </Grid>
	                
	                <Grid item md={4} xs={12}>
	                	<NumberFieldComp id='numeroMandatoFiduciario' aStyle={classes.textFieldWidthPerc} onError={this.handleError} required={this.isRequiredNumeroMandato()}
	                	onBlur={this.handleChangeDatiMandatoFiduciario} value={datiMandatoFiduciario.numeroMandatoFid} controlloDati={controlloDati}
	                	label='numeroMandatoFid' disabled={this.isDisabledNumeroMandato()} aStyleError={classes.textFieldWidthPercError} />
	                </Grid>
                	
	                	<Grid item md={4} xs={12}>
                        <RadioButtonComp id='intestatarioMandatoFid' radioComp={radioButtonIntestatarioMandato} onError={this.handleError}
                            controlloDati={controlloDati} required={this.isRequiredIntestatarioMandato()} onChange={this.handleChangeIntestatarioMandato}
                            selectedValue={datiMandatoFiduciario.intestatarioMandato} classes={{ divider: classes.divider }} disabled={this.isDisabledIntestatarioMandato()} />
                    </Grid>
                
                </Grid>
            </Fragment>
        )
    }
    
    isInError(prevProps, prevState) {   
        let isPresenteCampiConErrore = false;
    	this.state.statoCampi.map(unoStatoCampo => {
          return (		
            isPresenteCampiConErrore = isPresenteCampiConErrore || unoStatoCampo.isError
          );
    	});
        console.log('########DatiEsecutore componentDidUpdate this.state.statoCampi', this.state.statoCampi);
//    		    console.log('########DatiEsecutore componentDidUpdate isPresenteCampiConErrore', isPresenteCampiConErrore); 
//    		    console.log('########DatiEsecutore componentDidUpdate this.state.isPresenteErrore', this.state.isPresenteErrore);	
    	if (this.state.isPresenteErrore !== isPresenteCampiConErrore) {
          if (this.props.onError) {
            this.props.onError(this.props.id, isPresenteCampiConErrore);
          }
          this.setState({
            isPresenteErrore: isPresenteCampiConErrore,      
          });
    	}
      }
    
    componentDidUpdate(prevProps, prevState) {
//    	this.isResetComp(prevProps, prevState);
        this.isInError(prevProps, prevState);
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withStyles(styles)(DatiMandatoFiduciario)));
